import { render, staticRenderFns } from "./AS_PayBill2.vue?vue&type=template&id=05204050&scoped=true&"
import script from "./AS_PayBill2.vue?vue&type=script&lang=js&"
export * from "./AS_PayBill2.vue?vue&type=script&lang=js&"
import style0 from "./AS_PayBill2.vue?vue&type=style&index=0&id=05204050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05204050",
  null
  
)

export default component.exports